export default __webpack_public_path__ + "static/media/flow.8a4b9604.svg";